import React from "react";
import PropTypes from "prop-types";

import Button from "ui/Button";
import AnimatedModal from "components/Modal/AnimatedModal";

const ConfirmModal = ({ show, setShowConfirmModal, onSubscribe }) => {
    if (!show) {
        return null;
    }

    const onClose = () => {
        setShowConfirmModal(false);
    };

    const confirm = () => {
        onSubscribe();
        setShowConfirmModal(false);
    };

    return (
        <AnimatedModal
            visible={true}
            title="Только для совершеннолетних"
            onClose={onClose}
            closeOnOverlay={true}
        >
            {(close) => (
                <>
                    <p className="c-gs-medium-em text-center mb-24">
                        Организатор ограничил возраст участников, подтвердите
                        что вам есть 18 лет
                    </p>

                    <p className="c-gs-medium-em text-center mb-24">
                        Заполните ваш возраст в профиле и вам не придется каждый
                        раз подтверждать возраст
                    </p>

                    <div className="btn-group-row">
                        <Button
                            text
                            size="medium"
                            type="button"
                            onClick={close}
                        >
                            <span className="btn__span">Мне нет 18</span>
                        </Button>
                        <Button
                            primary
                            size="medium"
                            type="button"
                            onClick={confirm}
                        >
                            <span className="btn__span">Подтвердить</span>
                        </Button>
                    </div>
                </>
            )}
        </AnimatedModal>
    );
};

ConfirmModal.propTypes = {
    show: PropTypes.bool,
    setShowConfirmModal: PropTypes.func,
    onSubscribe: PropTypes.func,
};

export default ConfirmModal;
